import { FlagProvider } from '@unleash/proxy-client-react';
import type { PropsWithChildren } from 'react';
import { LocalStorageProvider } from 'unleash-proxy-client';

import { useAuth } from '@furality/frontend-stack';

const unleashConfig = {
  url: import.meta.env.PUBLIC_UNLEASH_FRONTEND_API_URL ?? '',
  clientKey: import.meta.env.PUBLIC_UNLEASH_FRONTEND_API_TOKEN ?? '',
  appName: import.meta.env.PUBLIC_UNLEASH_APP_NAME ?? '',
  environment: import.meta.env.MODE === 'production' ? 'production' : 'development',
  refreshInterval: 300,
  storageProvider: new LocalStorageProvider(),
};

const FeaturesProvider = ({ children }: PropsWithChildren) => {
  const { user } = useAuth();

  return (
    <FlagProvider
      config={{
        ...unleashConfig,
        context: {
          userId: user?.id,
        },
      }}
    >
      {children}
    </FlagProvider>
  );
};

export default FeaturesProvider;
